import promos from '@/data/promos';
import { Promo } from './contracts';

export function getPromoBySlug(slug: string): Promo | undefined {
  return promos.find((promo) => promo.slug === slug && promo.enabled);
}

export function getPromoByClubId(clubId: string | number): Promo | undefined {
  return promos.find((promo) => String(promo.clubId) === String(clubId) && promo.enabled);
}
